var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconScheduler = function SvgIconScheduler(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dock",
    transform: "translate(-320.000000, -489.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Appointments-Copy-16",
    transform: "translate(320.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2727273,12.7272727 L13.6363636,12.7272727 L13.6363636,9.09090909 L17.2727273,9.09090909 L17.2727273,12.7272727 Z M11.8181818,12.7272727 L8.18181818,12.7272727 L8.18181818,9.09090909 L11.8181818,9.09090909 L11.8181818,12.7272727 Z M6.36363636,12.7272727 L2.72727273,12.7272727 L2.72727273,9.09090909 L6.36363636,9.09090909 L6.36363636,12.7272727 Z M18.1818182,1.81818182 L16.3636364,1.81818182 L16.3636364,3.19744231e-14 L14.5454545,3.19744231e-14 L14.5454545,4.54545455 L12.7272727,4.54545455 L12.7272727,1.81818182 L7.27272727,1.81818182 L7.27272727,3.19744231e-14 L5.45454545,3.19744231e-14 L5.45454545,4.54545455 L3.63636364,4.54545455 L3.63636364,1.81818182 L1.81818182,1.81818182 C0.815454545,1.81818182 0,2.63454545 0,3.63636364 L0,17.2727273 C0,18.2754545 0.815454545,19.0909091 1.81818182,19.0909091 L18.1818182,19.0909091 C19.1845455,19.0909091 20,18.2754545 20,17.2727273 L20,3.63636364 C20,2.63454545 19.1845455,1.81818182 18.1818182,1.81818182 L18.1818182,1.81818182 Z",
    id: "Fill-2991"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconScheduler);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-scheduler.1bc30455cbb12a087e7e4d351e9933a7.svg";